module.exports = __webpack_public_path__ + "static/img/mac_ico.96c3bd4.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/mac_ico.svg
// module id = +k+5
// module chunks = 4